module.exports = __webpack_public_path__ + "static/img/led5mm.bb523a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/led5mm.svg
// module id = l5Sd
// module chunks = 0